import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "animate-pulse" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white rounded-xl border border-primary-200 p-4 mb-4"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-3 mb-3\"><div class=\"w-10 h-10 bg-primary-200 rounded-full\"></div><div class=\"flex-1\"><div class=\"h-4 bg-primary-200 rounded w-32 mb-1\"></div><div class=\"h-3 bg-primary-100 rounded w-20\"></div></div></div><div class=\"space-y-2\"><div class=\"h-4 bg-primary-200 rounded w-full\"></div><div class=\"h-4 bg-primary-200 rounded w-5/6\"></div><div class=\"h-4 bg-primary-100 rounded w-3/4\"></div></div>", 2)
const _hoisted_5 = [
  _hoisted_3
]
const _hoisted_6 = {
  key: 1,
  class: "bg-white rounded-xl border border-primary-200 p-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-5 bg-primary-200 rounded w-3/4 mb-3" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-100 rounded w-full" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-100 rounded w-5/6" })
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "p-3 bg-primary-50 rounded-lg"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-primary-200 rounded w-3/4 mb-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-100 rounded w-1/2" }, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  class: "bg-white rounded-xl border border-primary-200 p-4 text-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-8 bg-primary-200 rounded w-12 mx-auto mb-2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-primary-100 rounded w-20 mx-auto" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 4,
  class: "h-4 bg-primary-200 rounded w-full"
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type === 'post')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (__props.type === 'card')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
        : (__props.type === 'event')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
          : (__props.type === 'stat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
            : (_openBlock(), _createElementBlock("div", _hoisted_18))
  ]))
}
}

})